import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { getCampaignStatusText, getCampaignStatusStyles, CampaignStatus } from '../utils/campaignStatus';

interface CampaignStatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  status: CampaignStatus | string;
  useMaterialColors?: boolean; // Если true, использует стандартные цвета Material-UI, иначе кастомные стили
}

const CampaignStatusChip: React.FC<CampaignStatusChipProps> = ({ 
  status, 
  useMaterialColors = false,
  ...chipProps 
}) => {
  const statusText = getCampaignStatusText(status);
  
  if (useMaterialColors) {
    // Используем стандартные цвета Material-UI
    const color = status === 'active' ? 'success' :
                  status === 'paused' || status === 'pending_payment' ? 'warning' :
                  status === 'moderation' ? 'info' :
                  status === 'error' ? 'error' : 'default';
    
    return (
      <Chip 
        label={statusText}
        color={color as any}
        {...chipProps}
      />
    );
  }
  
  // Используем кастомные стили для единообразия
  const customStyles = getCampaignStatusStyles(status);
  
  return (
    <Chip 
      label={statusText}
      sx={customStyles}
      {...chipProps}
    />
  );
};

export default CampaignStatusChip;

